module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"save_as_image":"画像で保存","save_as_csv":"CSVで保存"},"en":{"save_as_image":"Save as Image","save_as_csv":"Save as CSV"}}')
  delete Component.options._Ctor
}
